<template>
  <div
    class="contact-info-bar"
    :class="{
      'contact-info-bar--white': variant === 'white',
      'contact-info-bar--green': variant === 'green',
    }">
    <b-container>
      <b-row>
        <b-col>
          <p class="contact-info-bar__text">
            Dúvidas ou sugestões? Entre em contato através do email cronicasrs@saude.rs.gov.br
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'contact-info-bar',
  props: {
    variant: {
      type: String,
      default: 'white',
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-info-bar {
  .contact-info-bar__text {
    margin: 1.575rem auto;
    color: #0A594F;
    line-height: 1.5625;
    text-shadow: 0px 0px 1px #0a594f;
  }
  &.contact-info-bar--white {
    background-color: #FFF;
  }
  &.contact-info-bar--green {
    background-color: rgba(11, 91, 81, .3);
  }
}

@include media-breakpoint-up(lg) {
  .contact-info-bar {
    .contact-info-bar__text {
      font-size: 1.125rem;
      text-align: center;
    }
  }
}
</style>
